import { useState } from "react";
import { AppLayout } from "../../components/layout/Header";
import InstallInstructionsModal from "../../components/modals/InstallInstructionsModal";

const WINDOWS_SETUP = "/downloads/REChecklist-Setup.exe";

export default function InstallPage() {
  const [open, setOpen] = useState(false);

  return (
    <AppLayout>
      <div className="install-page card">
        <h1>Install REChecklist</h1>
        <p className="lead">
          Use REChecklist as a dedicated Windows app, or add the web experience to your phone home
          screen.
        </p>

        <section className="install-block">
          <h2>Windows desktop app</h2>
          <p>
            Download the installer for a professional desktop window pointed at REChecklist —
            Start Menu and desktop shortcuts included.
          </p>
          <p className="btn-row btn-row--left">
            <a className="primary-btn" href={WINDOWS_SETUP} download>
              Download Windows Installer
            </a>
          </p>
          <ol className="install-instructions">
            <li>Download <strong>REChecklist-Setup.exe</strong>.</li>
            <li>Run the installer and follow the prompts.</li>
            <li>Launch <strong>REChecklist</strong> from the Start Menu or desktop shortcut.</li>
          </ol>
        </section>

        <section className="install-block">
          <h2>Phone home screen</h2>
          <p>Turn the site into a convenient app icon on your phone.</p>
          <button type="button" className="primary-btn" onClick={() => setOpen(true)}>
            Show Phone Instructions
          </button>
        </section>

        <InstallInstructionsModal isOpen={open} onClose={() => setOpen(false)} />
      </div>
    </AppLayout>
  );
}
